<template>
    <div id="login" v-show="!account.account.login">
        <div>
            <h1>IDC Телевидение</h1>
            <div>
                <form action="" @submit.prevent="getLogin">
                    <label>Абонемент</label>
                    <input type="number" v-model.number="login.abo">
                    <label>Пароль</label>
                    <input type="password" v-model.number="login.pass">
                    <button type="submit">Войти</button>
                </form>
                <a href="http://www.idc.md/tv/iptv/connect.php" id="shop"><i class="icon-basket"></i> Подключение к IPTV</a>
            </div>
            <br class="clear">
            <h2>Техподдержка: 1198</h2>
            <div v-show="error.code === 11" class="error-msg">Абонемент используется на другом устройстве</div>
        </div>
    </div>
</template>
<script>
    import Server from './../libs/server'
    import {mapState, mapActions} from 'vuex'

    export default {
        data() {
            return {
                login: {
                    abo: '',
                    pass: ''
                }
            }
        },
        computed: {
            ...mapState({
                account: state => state.login.account,
                error: state => state.error.errorObject,
            })
        },
        methods: {
            ...mapActions([
                'makeLogin',
                'makeLogout',
                'showError',
                'showToast',
                'setCurrentChannel',
                'setProtectionCode',
                'setShowHiddenChannels',
                'hideTab'
            ]),
            getLogin() {
                this.makeLogin({
                    abo: this.login.abo,
                    pass: this.login.pass
                })
                    .then(() => {
                        this.$parent.apiGetAccount();
                        this.login.pass = '';
                    })
                    .catch(err => {
                        console.log(err);
                        this.showError(err);
                    });

                if (this.account && this.account.account.login)
                    this.$parent.apiGetChannelList()
            },
            getLogout() {
                this.setCurrentChannel(false);
                this.hideTab();
                this.setProtectionCode('');
                this.setShowHiddenChannels(false);

                this.makeLogout()
                    .then(() => {
                        this.login.abo = '';
                        this.showToast({
                            message: 'Вы вышли из аккаунта'
                        });
                    })
                    .catch(err => {
                        this.showError(err);
                    });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// Login.vue?109b0c2e